import React, { useEffect, useState } from 'react'
import constant from '../../../constant'
import InterviewAnswerList from '../../../component/Utilities/InterviewQuestion/InterviewAnswer'
import { answerlistbyQuestionId, archiveInterviewAnswer, deleteAnswerByQuestionId } from '../../../actions/utilitiesAction'
import { useParams } from 'react-router-dom'
import Swal from 'sweetalert2'

export default function InterviewAnswer() {

    const [list, setList] = useState([])
    const [count, setCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [showLoader, setShowLoader] = useState(false)
    const [questionTitle, setQuestionTitle] = useState("")
    const params = useParams()

    useEffect(() => {
        getInterviewAnswerList(currentPage)
        document.title = constant.title.InterviewAnswer
    }, [currentPage])

    const getInterviewAnswerList = (page) => {
        const INTERVIEW_QUESTIONS_ID = params.id
        setShowLoader(true)
        answerlistbyQuestionId(INTERVIEW_QUESTIONS_ID, page).then((res) => {
            if (res.status) {
                setQuestionTitle(res.result.list1.QUESTION_TITLE)
                setShowLoader(false)
                setList(res.result.list)
                setCount(res.result.count)
            }
            else {
                alert(res.error)
            }
        }).catch((err) => {
            alert(err)
        })
    }

    const updateStatus = (model) => {
        archiveInterviewAnswer(model).then((res) => {
            if (res.status) {
                getInterviewAnswerList(currentPage, '')
            } else {
                alert(res.error)
            }
        }).catch((err) => {
            alert(err)
        })
    }

    const deleteAnswerId = (INTERVIEW_QUESTIONS_ANSWER_ID) => {
        deleteAnswerByQuestionId({ INTERVIEW_QUESTIONS_ANSWER_ID: INTERVIEW_QUESTIONS_ANSWER_ID }).then((res) => {
            if (res.status) {
                Swal.fire(
                    'Deleted!',
                    'Your Answer has been deleted.',
                    'success'
                )
                getInterviewAnswerList(currentPage)
            }
            else {
                Swal.fire(
                    (res.result.error)
                )
            }

        })
    }


    return (
        <React.Fragment>
            <InterviewAnswerList
                list={list}
                getInterviewAnswerList={(page => getInterviewAnswerList(page))}
                count={count}
                setPage={setCurrentPage}
                showLoader={showLoader}
                updateStatus={updateStatus}
                deleteAnswerId={deleteAnswerId}
                questionTitle={questionTitle}
            />
        </React.Fragment>
    )
}
